module.exports = __webpack_public_path__ + "img/icon-save-medium.91b23a26.svg";